import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Logo from '../../svg/icons/logo.svg';

import TranslationProvider, { getTranslation } from '../../providers/TranslationProvider';
import './PoweredBy.scss';

const PoweredBy = (props) => {
  const { hideCopy } = props;
  return (
    <div
      className={cx('PoweredBy', {
        'PoweredBy--hide-copy': hideCopy,
      })}
      role="img"
      aria-label={getTranslation({ translationKey: '"powered_by_resy": "Powered by Resy",', fallback: 'Powered by Resy' })}
    >
      {!hideCopy && (
        <TranslationProvider
          translationKey="powered"
        >
          <span
            className="PoweredBy__copy"
            aria-hidden="true"
          >
            Powered by
          </span>
        </TranslationProvider>
      )}
      <span
        className="PoweredBy__logo"
        aria-hidden="true"
      >
        <Logo />
      </span>
    </div>
  );
};

PoweredBy.propTypes = {
  hideCopy: PropTypes.bool,
};

PoweredBy.defaultProps = {
  hideCopy: false,
};

PoweredBy.displayName = 'PoweredBy';
export default PoweredBy;
